import { render } from "./WithdrawSetting.vue?vue&type=template&id=31ba7bf6&scoped=true"
import script from "./WithdrawSetting.vue?vue&type=script&lang=js"
export * from "./WithdrawSetting.vue?vue&type=script&lang=js"

import "./WithdrawSetting.vue?vue&type=style&index=0&id=31ba7bf6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ba7bf6"]])

export default __exports__